module.exports = __webpack_public_path__ + "static/media/FHTD.3fda3115.jpg";